<template>  
    <div class="row">
      <div class="col-12">
        <page-header
          left-side-class="col-12 col-md-7"
          :page="headerConfig"
          :actions="pageActionConfig"
          right-side-class="col-12 col-md-5 d-flex align-items-end mb-2"
        />                 
        
        <div class="bg-gray-1 p-3 mt-3 ml-3 mr-3">     
            <div class="col-12">
                <icon-view                 
                icon="fas fa-user-plus color-orange" 
                iconBackground="#ffffff"
                title="Búsqueda de Estudiantes" 
                />   

                <div class="row py-2 mt-2">
                    <div class="col-12 col-md-5">                    
                        <custom-input                    
                            v-model="filterModel.studentSieId"
                            placeholder="Escriba Número de SIE"                           
                            left-icon
                            type="number"
                            icon="fa fa-search orange-icon"                  
                        />                        
                    </div>
                    <div class="col-12 col-md-4">
                        <action-button
                            text="Buscar"
                            variant="success"
                            i="fas fa-search"
                            :class="['px-4']"
                            @click="onSearchHandler()"
                        />        
                    </div>
                </div>
            </div>
        </div>
        <custom-separator class="mt-4 custom-separator-line" text="Resultados" />

        <custom-result-not-found
          v-if="results.length == 0"
          :text="'No hay información disponible.'"
        />
        <template v-else>
          <ResultRow
            v-for="(row, index) of results"
            :key="`result-${index}`"
            class="mb-3"
            :data="row"          
          />
          <pagination
            v-if="pagination.totalItemCount > pagination.pageSize"
            :data="pagination"
            show-text
            @pagination-go-page="goToPageHandler"
          />
        </template>
      </div>
    </div>
</template>

<script>
import PageHeader from "PageHeader";
import FilterManager from "FilterManager";
import CustomSeparator from "custom-separator";
import CustomInput from "CustomInput";
import ActionButton from 'ActionButton'
import IconView from "icon-view";
import CustomResultNotFound from "custom-result-not-found";
import Pagination from "pagination";
import ResultRow from "./components/ResultRow.vue";
import autismSurveillanceNetworkService from "@/services/autismSurveillanceNetwork"

const DEFAULT_PAGE_SIZE = 10;

export default {
  name: "AutismSurveillanceNetwork",  
  components: {
    PageHeader,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
    CustomInput,
    ActionButton,
    IconView,
    Pagination,
    ResultRow
  },
  data: () => ({
    filterModel: {
      studentSieId: null,      
    },
    pagination: {
      currentPage: 1,
      totalItemCount: 1,
      pageCount: 1,
      count: 1,
      pageSize: DEFAULT_PAGE_SIZE
    },
    results: []
  }),
  computed: {  
    pageActionConfig() {
        return [
            {
                text: 'Regresar',
                icon: 'fas fa-arrow-circle-left',
                variant: 'outline-success',
                click: () => this.back(),
            },
        ];
    },
    headerConfig() {
      return {
        title: "Red de vigilancia de autismo",            
        icon: "fas fa-user-circle",
        routes: [
          "Inicio",
          "Estudiante",
          "Red de vigilancia de autismo"          
        ]
      };
    }       
  },
  async mounted() {    
    this.results = [];
    this.pagination.pageIndex = 1;
    await this.search();
  }, 
  methods: {   
    back() {
        this.$router.push({ name: 'student-menu'});
    },    
    async onSearchHandler() {
      this.pagination.pageIndex = 1;           
    
      this.search();
    },    
    async search() {
      
      const payload = {
        studentSieId: this.filterModel.studentSieId,
        pageIndex : this.pagination.pageIndex,
        pageSize: this.pagination.pageSize
      }      

      const { data } = await autismSurveillanceNetworkService.getStudents(payload)
        
      this.results = data.data

      this.pagination = {
        ...this.pagination,
        count: data.count,
        currentPage: data.currentPage,
        pageCount: data.pageCount,
        totalItemCount: data.totalItemCount
      };
    },
    async goToPageHandler(page) {   
      this.pagination.pageIndex = page;
      await this.search();
    },   
  }
};
</script>
